const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/eCheckin/components/fields/AHVField.tsx';
import * as React from 'react';
import { forwardRef } from 'react';
import { useCIS4m } from '@cistec/common_web/modules/CIS4m/hooks';
import { validateAHV, ValidationFunction } from '@cistec/common_web/components/Forms/utils/validation';
import { TextInput, useOptionalText, useText } from '@cistec/common_web/utils/intlUtils';
import { CIS4mMaskedTextField } from '@cistec/common_web/modules/CIS4m/components/CIS4mMaskedTextField';

interface Props {
    label: TextInput;
    helperText?: TextInput;
    path: string;
    checkValidity?: ValidationFunction;
    hidden?: boolean;
    required?: boolean;
    mask?: string;
}

export const AHVField = forwardRef((props: Props, ref: any) => {
    const textFieldRef = useCIS4m(ref);

    const label = useText(props.label);
    const helperText = useOptionalText(props.helperText);
    const hidden = props.hidden ?? false;
    const required = props.required ?? false;
    const mask = props.mask ?? '756.9999.9999.99';

    const checkValidity = props.checkValidity ?? validateAHV;

    return (
        <CIS4mMaskedTextField
            ref={textFieldRef}
            label={label}
            helperText={helperText}
            path={props.path}
            checkValidity={checkValidity}
            mask={mask}
            hidden={hidden}
            required={required}
        />
    );
});

AHVField.displayName = 'AHVField';
